<div class="configuration-page">
  <div class="configuration-page-header">
    <div class="configuration-page-header-title">
      <h3 class="title">{{ 'Configurations.Title_GG' | translate }}</h3>
    </div>
  </div>
  <div class="configuration-page-container">
    <div class="configuration-left-column">
      <div class="config-properties">
        <div class="config left-align">
          {{ 'Configurations.IFRAME' | translate | uppercase }}
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="size-input-label">{{'Configurations.Width' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <mat-form-field class="size-input">
              <span matSuffix>px</span>
              <input
                class="iframeWidth"
                matInput
                [formControl]="formGroupChanges.get('iframeWidth')"
                type="number"
                max="1000"
                min="0"
                inputMask="0*"
                (change)="changeInput()"
              >
            </mat-form-field>
          </div>
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="size-input-label">{{'Configurations.Height' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <mat-form-field class="size-input">
              <span matSuffix>px</span>
              <input
                matInput
                [formControl]="formGroupChanges.get('iframeHeight')"
                type="number"
                max="1000"
                min="0"
                inputMask="0*"
                (change)="changeInput()"
              >
            </mat-form-field>
          </div>
        </div>
        <div class="config left-align">
          {{ 'Configurations.FONT' | translate | uppercase }}
        </div>
        <div>
          <app-editor-input
            placeholder="Configurations.FONT"
            [form]="formGroupChanges"
            [optionsList]="fontTypes"
            class="full-width"
            [control]="formGroupChanges.get('fontType')"
            (click)="changeInput()"
          >
          </app-editor-input>
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="size-input-label">{{'Configurations.Size' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <mat-form-field class="size-input">
              <span matSuffix>px</span>
              <input
                matInput
                [formControl]="formGroupChanges.get('fontSizeP')"
                type="number"
                min="1"
                max="99"
                inputMask="0*"
                (change)="changeInput()"
              >
            </mat-form-field>
          </div>
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="colorLabel">{{'Configurations.Color' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <input
              class="color-input"
              type="color"
              [formControl]="formGroupChanges.get('fontColor')"
              (change)="changeInput()"
            />
          </div>
        </div>
        <div class="left-align config">
          {{ 'Configurations.Blocks' | translate | uppercase }}
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="colorLabel">{{'Configurations.Color' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <input
              class="color-input"
              type="color"
              [formControl]="formGroupChanges.get('backgroundTextColor')"
              (change)="changeInput()"
            />
          </div>
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="colorLabel">{{'Configurations.BackgroundColor' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <input
              class="color-input"
              type="color"
              [formControl]="formGroupChanges.get('backgroundColor')"
              (change)="changeInput()"
            />
          </div>
        </div>
        <div class="left-align config">
          {{ 'Configurations.INPUTS' | translate | uppercase }}
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="colorLabel">{{'Configurations.Color' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <input
              class="color-input"
              type="color"
              [formControl]="formGroupChanges.get('inputColor')"
              (change)="changeInput()"
            />
          </div>
        </div>
        <div class="config-properties-row">
          <div class="config-properties-label">
            <span class="colorLabel">{{'Configurations.BorderColor' | translate}}</span>
          </div>
          <div class="config-properties-value">
            <input
              class="color-input"
              type="color"
              [formControl]="formGroupChanges.get('inputBorderColor')"
              (change)="changeInput()"
            />
          </div>
        </div>
        <div class="left-align config">
          {{ 'Configurations.ClosingText' | translate | uppercase }}
        </div>
        <div class="closing-text">
          <textarea
            rows="5"
            matInput
            [formControl]="formGroupChanges.get('closingText')"
            (change)="changeInput()"
          ></textarea>
        </div>
        <div class="left-align config">
          {{ 'Configurations.IntermediarySettings' | translate | uppercase }}
        </div>
        <div>
          <form class="example-form">
            <mat-form-field class="full-width">
              <mat-label>{{'Configurations.Email' | translate}}</mat-label>
              <input
                matInput
                [formControl]="formGroupChanges.get('emailFormControl')"
                (change)="changeInput()"
              >
              <mat-error
                *ngIf="formGroupChanges.get('emailFormControl').hasError('email') && !formGroupChanges.get('emailFormControl').hasError('required')"
              >
                {{ 'Configurations.InvalidEmail' | translate }}
              </mat-error>
              <mat-error *ngIf="formGroupChanges.get('emailFormControl').hasError('required')"
              >
                {{ 'Configurations.MissingEmail' | translate }}
              </mat-error>
            </mat-form-field>
          </form>
        </div>
        <div class="input-and-checkbox-wrapper">
          <app-text-input
            class="full-width"
            placeholder="Configurations.IntermediaryFee"
            [form]="formGroupChanges"
            [control]="intermediaryFeeControl"
            inputMask="0*.00"
            prefix="€ "
            required
            [isDisabled]="!this.formGroupChanges.get('showIntermediaryFee')?.value"
          ></app-text-input>
          <div class="checkbox-wrapper">
            <app-checkbox-input
              placeholder=""
              [form]="formGroupChanges"
              [control]="showIntermediaryFeeControl"
            ></app-checkbox-input>
          </div>
        </div>
        <app-select-box
          placeholder="Configurations.IntermediaryFeePeriod"
          [form]="formGroupChanges"
          [optionsList]="intermediaryFeePeriodList"
          [control]="intermediaryFeePeriodControl"
          appConfigSettingsParagraph
          appConfigSettingsBackground
          [isDisabled]="!this.formGroupChanges.get('showIntermediaryFee')?.value"
        ></app-select-box>
        <div class="input-and-checkbox-wrapper">
          <p class="checkbox-for-subscription-wrapper">{{"Calculator.SubscriptionFees" | translate}} <app-checkbox-input
            placeholder=""
            [form]="formGroupConfig"
            [control]="showIntermediarySubscriptionFeeControl"
          ></app-checkbox-input></p>
        </div>
        <div class="subscription-fee-wrapper">
          <app-text-input
            class="full-width"
            placeholder=" "
            [form]="formGroupChanges"
            [control]="intermediarySubscriptionFeeControl"
            inputMask="0*.00"
            prefix="€ "
            required
            [isDisabled]="!this.formGroupChanges.get('showIntermediarySubscriptionFee')?.value"
          ></app-text-input>
        </div>
        <app-select-box
          placeholder="Configurations.SubscriptionFeesPeriod"
          [form]="formGroupChanges"
          [optionsList]="intermediarySubscriptionFeePeriodList"
          [control]="intermediarySubscriptionFeePeriodControl"
          appConfigSettingsParagraph
          appConfigSettingsBackground
          [isDisabled]="!this.formGroupChanges.get('showIntermediarySubscriptionFee')?.value"
        ></app-select-box>
        <div class="left-align config">
          {{ 'Configurations.FinalStatementAddition' | translate }}
        </div>
        <div class="closing-text">
          <textarea
            rows="5"
            matInput
            [formControl]="finalStatementAdditionControl"
          ></textarea>
          <mat-error *ngIf="isAnyErrorForFinalStatementAddition" class="error-message">
            <ng-container *ngIf="finalStatementAdditionControl.errors?.message">
              {{ finalStatementAdditionControl.errors.message }}
            </ng-container>
          </mat-error>
        </div>
        <div class="configuration-buttons-container mt-10">
          <div>
            <button
              type="button"
              [disabled]="buttonDisabled"
              class="primary primary-config-button"
              (click)="saveConfigSettings()"
            >
              {{ 'Configurations.SaveConfiguration' | translate }}
            </button>
          </div>
          <div>
            <button
              type="button"
              class="primary primary-config-button"
              (click)="generateCode()"
            >
              {{ 'Configurations.GenerateSnippet' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="configuration-right-column">
      <div
        class="example"
        [style.width.px]="formGroupChanges.get('iframeWidth').value"
        [style.height.px]="formGroupChanges.get('iframeHeight').value"
        [style.font-family]="FontTypeEnum[formGroupChanges.get('fontType').value]"
        [style.color]="formGroupChanges.get('fontColor').value"
      >
        <h1
          class="calculation-title"
          [style.backgroundColor]="formGroupChanges.get('backgroundColor').value"
          [style.color]="formGroupChanges.get('backgroundTextColor').value"
          [style.font-size.px]="(formGroupChanges.get('fontSizeP').value) * 2"
        >
          {{ "ApplicationPage.GG_Title" | translate }}
        </h1>
        <div class="example-container">
          <div class="insured">
            <h2
              [style.font-size.px]="(formGroupChanges.get('fontSizeP').value)*1.5"
              [style.color]="formGroupChanges.get('fontColor').value"
            >
              {{ "Calculation.SecondTitle" | translate }}
            </h2>
            <div
              [style.font-size.px]="formGroupChanges.get('fontSizeP').value"
              [style.color]="formGroupChanges.get('fontColor').value"
            >
              <div>
                <app-autocomplete-input
                  class="full-width"
                  placeholder="Insured.Occupation"
                  [form]="formGroupConfig"
                  [control]="formGroupConfig.get('occupation')"
                  [dataSource]="selectOccupationsList"
                  showPlaceholder="false"
                  [isDefaultValueSetAfterOptionListChanged]="false"
                  [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                  [inputColor]="formGroupChanges.get('inputColor').value"
                  [fontColor]="formGroupChanges.get('fontColor').value"
                  [fontSize]="formGroupChanges.get('fontSizeP').value"
                ></app-autocomplete-input>
              </div>
              <app-date-input
                placeholder="CalculationInsurer.DateOfBirth"
                [form]="formGroupConfig"
                [control]="formGroupConfig.get('dateOfBirth')"
                [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                [inputColor]="formGroupChanges.get('inputColor').value"
                [fontColor]="formGroupChanges.get('fontColor').value"
                [fontSize]="formGroupChanges.get('fontSizeP').value"
              ></app-date-input>
              <div>
                <app-text-input
                  appConfigSettingsInput
                  placeholder="Insured.MonthlyAmount"
                  [control]="formGroupConfig.get('sumAssured')"
                  [form]="formGroupConfig"
                  showPlaceholder="false"
                  inputMask="separator.0"
                  [thousandSeparator]="thousandSeparator"
                  prefix="€ "
                  additionalInfoInsurer="Common.MonthlyAmountValidationMessage"
                  isCalculatorShown="true"
                  [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                  [inputColor]="formGroupChanges.get('inputColor').value"
                  [fontColor]="formGroupChanges.get('fontColor').value"
                  [fontSize]="formGroupChanges.get('fontSizeP').value"
                ></app-text-input>
              </div>
              <div>
                <app-toggle-input
                  [groupBy2InLine]="true"
                  placeholder="CalculationInsurer.BenefitDuration"
                  freeText="CalculationInsurer.BenefitDurationExplanation"
                  [form]="formGroupConfig"
                  [optionsList]="durationList"
                  [control]="formGroupConfig.get('claimDuration')"
                  appConfigSettingsParagraph
                  required
                  isRequiredMessageKey="Calculation.RequiredField"
                  [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                  [inputColor]="formGroupChanges.get('inputColor').value"
                  [fontColor]="formGroupChanges.get('fontColor').value"
                  [fontSize]="formGroupChanges.get('fontSizeP').value"
                ></app-toggle-input>
              </div>
              <div>
                <app-select-box
                  class="yearInput"
                  placeholder="Insured.StartDate"
                  [form]="formGroupConfig"
                  [control]="formGroupConfig.get('dateOfCommencement')"
                  [optionsList]="datesArray"
                  required
                  isRequiredMessageKey="Calculation.RequiredField"
                  [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                  [inputColor]="formGroupChanges.get('inputColor').value"
                  [fontColor]="formGroupChanges.get('fontColor').value"
                  [fontSize]="formGroupChanges.get('fontSizeP').value"
                ></app-select-box>
              </div>
              <br>
              <div>
                <app-toggle-input
                  [groupBy2InLine]="true"
                  placeholder="ProductInfo.RiskDuration"
                  [form]="formGroupConfig"
                  [optionsList]="waitingPeriodList"
                  [control]="formGroupConfig.get('waitingPeriod')"
                  isRequiredMessageKey="Calculation.RequiredField"
                  [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                  [inputColor]="formGroupChanges.get('inputColor').value"
                  [fontColor]="formGroupChanges.get('fontColor').value"
                  [fontSize]="formGroupChanges.get('fontSizeP').value"
                ></app-toggle-input>
              </div>
              <div>
                <app-toggle-input
                  [groupBy2InLine]="true"
                  placeholder="ProductInfo.MentalIllness"
                  [form]="formGroupConfig"
                  [optionsList]="yesNoList"
                  [control]="formGroupConfig.get('mentalIllness')"
                  required
                  isRequiredMessageKey="Calculation.RequiredField"
                  [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                  [inputColor]="formGroupChanges.get('inputColor').value"
                  [fontColor]="formGroupChanges.get('fontColor').value"
                  [fontSize]="formGroupChanges.get('fontSizeP').value"
                ></app-toggle-input>
              </div>
              <div>
                <app-toggle-input
                  [groupBy2InLine]="true"
                  placeholder="ProductInfo.IndexationUsage"
                  [form]="formGroupConfig"
                  [optionsList]="yesNoList"
                  [control]="formGroupConfig.get('indexationUsage')"
                  required
                  isRequiredMessageKey="Calculation.RequiredField"
                  [inputBorderColor]="formGroupChanges.get('inputBorderColor').value"
                  [inputColor]="formGroupChanges.get('inputColor').value"
                  [fontColor]="formGroupChanges.get('fontColor').value"
                  [fontSize]="formGroupChanges.get('fontSizeP').value"
                ></app-toggle-input>
              </div>
            </div>
          </div>
          <div class="mt-10">
            <button
              type="button"
              class="primary"
              [style.background-color]="formGroupChanges.get('backgroundColor').value"
              [style.color]="formGroupChanges.get('backgroundTextColor').value"
            >
              {{ "Calculation.Calculate" | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="snippet-container">
        <div>
          <label for="code">
            {{ 'Configurations.GeneratedSnippet' | translate }}
          </label>
        </div>
        <div class="snippet">
          <textarea
            matInput
            rows="5"
            id="code"
            type="text"
            [(ngModel)]="snippetCode"
          ></textarea>
        </div>
        <div class="mt-10">
          <button
            type="button"
            class="primary primary-config-button"
            [appCopyClipboard]="snippetCode"
          >
            {{ 'Configurations.CopyToClipboard' | translate }}
          </button>
        </div>
      </div>
      <div class="snippet-container">
        <app-text-input
          class="full-width"
          placeholder="Configurations.Url"
          [form]="formGroupChanges"
          [control]="urlControl"
        ></app-text-input>
      </div>
    </div>
  </div>
</div>
